const config = {
    api: {
        baseUrl: 'https://demodashboardapi.shipsy.io/api',
        endpoints: {
            updateUserPreference: '/CRMDashboard/userPreference',
            getNotificationAuthToken: '/CRMDashboard/notification/getAuthToken',
        },
    },
    firebase: {
        config: {
            apiKey: 'AIzaSyBS7-u48IAJzePDpwM-nbKNXULw8kD7HL4',
            authDomain: 'notification-service-418009.firebaseapp.com',
            projectId: 'notification-service-418009',
            storageBucket: 'notification-service-418009.appspot.com',
            messagingSenderId: '413910393309',
            appId: '1:413910393309:web:18279bf70b4ef30ee9d634',
        },
        firestoreDbId: 'notification-service-demo',
        vapidKey: 'BMJxxP73j8ok0wOvo5Ak_qked8D9oZW4-FhMsqie5JGh08HUvWcWpQKuX7vT2KIzQ9ahK7Q8ujQdcs15G7y8m4A',
    },
    notifications: {
        pollingInterval: 30000,
        pageSize: 10,
        maxDaysHistory: 30,
    },
    ui: {
        iconColor: '#FFFFFF',
        iconColorActive: '#40A9FF',
        position: 'top-right',
        LiaCoPilotMode: false,
    },
};

module.exports = config;

